import React from 'react';
import '../styles/ZwykUseCase.css';

interface ZwykUseCaseProps {
  imageUrl: string;
  imgHeader: string;
  description: string;
}

const ZwykUseCase: React.FC<ZwykUseCaseProps> = ({ imageUrl, imgHeader, description }) => {
  return (
    <div className="zwyk-use-case-container">
      <div 
        className="zwyk-use-case"
        style={{ backgroundImage: `url(${imageUrl})` }}
        data-aos="fade-down" data-aos-delay={100}
      >
        <h1 className="zwyk-use-case-header" data-aos="fade-down" data-aos-delay={100}>{imgHeader}</h1>
      </div>
      <p className="zwyk-use-case-description" data-aos="fade-down" data-aos-delay={200}>{description}</p>
    </div>
  );
};

export default ZwykUseCase; 